import { FunctionComponent, SVGProps } from 'react';
import { batch } from 'react-redux';

import { defaultSearchData } from 'components/Popups/DesktopSearch/data';
import { MobileBurger } from 'components/Reusable';
import { defaultSongsModuleFilterData } from 'components/Songs/data';

import {
  dispatch,
  getActiveNavItemId,
  getIsOpenSidebar,
  getSelectors,
  setIsOpenSidebar,
  setSearchData,
  setSongsModule,
  toggleIsOpenSearch,
  toggleIsOpenTopMenu,
} from 'store';
import { SEARCH_ID_PAGE_ROUTE_ID, SEARCH_PAGE_ROUTE_ID } from 'utils';

import { ReactComponent as NotificationIcon } from 'assets/notification.svg';
import { ReactComponent as ProfileIcon } from 'assets/profile.svg';
import { ReactComponent as SearchIcon } from 'assets/search.svg';

import SidebarIcon from './SidebarIcon';

export interface IToolbarItem {
  id: number;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  className: string;
  isAdditionalRoutes?: boolean;
  onClick?: () => void;
}

const ToolbarData: IToolbarItem[] = [
  {
    id: 1,
    Icon: SearchIcon,
    className: 'searchBtn',
    onClick: () => {
      const activeNavItemId = getSelectors(getActiveNavItemId);

      batch(() => {
        dispatch(toggleIsOpenSearch());
        if (![SEARCH_PAGE_ROUTE_ID, SEARCH_ID_PAGE_ROUTE_ID].includes(activeNavItemId)) return;

        dispatch(setSearchData(defaultSearchData));
        dispatch(setSongsModule({ filtersData: defaultSongsModuleFilterData }));
      });
    },
  },
  {
    id: 2,
    Icon: NotificationIcon,
    className: 'notificationBtn',
  },
  {
    id: 3,
    Icon: ProfileIcon,
    className: 'profileBtn',
    isAdditionalRoutes: true,
  },
  {
    id: 4,
    Icon: SidebarIcon,
    className: 'burgerBtn',
    onClick: () => dispatch(setIsOpenSidebar(!getSelectors(getIsOpenSidebar))),
  },
  {
    id: 5,
    Icon: MobileBurger,
    className: 'mobileBurgerBtn',
    onClick: () => dispatch(toggleIsOpenTopMenu()),
  },
];

export default ToolbarData;
